import React, { forwardRef } from 'react';
import { Chip, Stack, Typography } from '@mui/material';

export const OverflowChips = forwardRef(
	(
		{ items, limitTags, getLabel = (item) => item, getChipProps = () => ({}), ...stackProps },
		ref,
	) => {
		const visible = items.slice(0, limitTags);
		const hidden = items.slice(limitTags);

		return (
			<Stack ref={ref} direction='row' spacing={0.5} alignItems='center' {...stackProps}>
				{visible.map((item, index) => (
					<Chip key={index} size='small' label={getLabel(item)} {...getChipProps(item)} />
				))}
				{hidden.length > 0 && (
					<Typography variant='body2' sx={{ whiteSpace: 'nowrap' }}>
						{`+${hidden.length}`}
					</Typography>
				)}
			</Stack>
		);
	},
);

OverflowChips.displayName = 'OverflowChips';
